import { useEffect } from 'react'
import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigateToList } from '@/hooks/useNavigateToList'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { useThemeColors } from '@/hooks/useThemeColors'
import { BookingForm } from '@/components/forms/BookingForm'

export default function BookingCreatePage() {
  const colors = useThemeColors()
  const navigateToList = useNavigateToList('/bookings')

  const handleSuccess = () => {
    navigateToList()
  }

  const handleCancel = () => {
    navigateToList()
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create Booking</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Input the information for the following
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <BookingForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
